module.exports = __webpack_public_path__ + "img/formsTrapezSEL.492832b9.svg";